/**
 * Auto-generated from error-codes.json
 * DO NOT EDIT THIS FILE MANUALLY
 *
 * This file is generated by generate-error-codes-ts.js
 */

export const errorCodesData: Record<string, string> = {
    '0X0001': 'An unspecified error has occurred',
    '0X0002': 'An invalid _VarType_ has been used',
    '0X0003': 'The command was not recognized',
    '0X0004': 'Unknown register',
    '0X0005': 'Register is read-only',
    '0X0006': 'Communication mode invalid',
    '0X0007': 'An argument has an unexpected value',
    '0X0008': 'Command exceeds maximum length',
    '0X0009': 'The command has timed out',
    '0X000B': 'Cannot reserve the memory needed for this var',
    '0X000C': 'Cannot run a script without loading one first',
    '0X000E': 'An overflow has occurred while averaging a measured value',
    '0X000F': 'The given potential is not valid',
    '0X0010': 'A variable has become either "NaN" or "inf"',
    '0X0011': 'The input frequency is invalid',
    '0X0012': 'The input amplitude is invalid',
    '0X0014': 'Cannot perform OCP measurement when cell on',
    '0X0015': 'CRC invalid',
    '0X0016': 'An error has occurred while reading / writing flash',
    '0X0017': 'The specified flash address is not valid for this device',
    '0X0018': 'The device settings have been corrupted',
    '0X0019': 'Authentication error',
    '0X001A': 'Calibration invalid',
    '0X001B': 'This command or part of this command is not supported by the current device',
    '0X001C': 'Step Potential must at least 1 DAC LSB for this technique',
    '0X001D': 'Pulse Potential must at least 1 DAC LSB for this technique',
    '0X001E': 'Amplitude must at least 1 DAC LSB this technique',
    '0X001F': 'Product is not licensed for this technique',
    '0X0020': 'Cannot have more than one high speed and/or max range mode enabled',
    '0X0021': 'The specified PGStat mode is not supported',
    '0X0022': 'Channel set to be used as Poly WE is not configured as Poly WE',
    '0X0023': 'Command is invalid for the selected PGStat mode',
    '0X0024': 'The maximum number of vars to measure has been exceeded',
    '0X0025': 'The specified PAD mode is unknown',
    '0X0026': 'An error has occurred during a file operation',
    '0X0027': 'Cannot open file, a file with this name already exists',
    '0X0028': 'Variable divided by zero',
    '0X0029': 'GPIO pin mode is not known by the device',
    '0X002A': 'GPIO configuration is incompatible with the selected operation',
    '0X002B': 'CRC of received line was incorrect (CRC16-ext)',
    '0X002C': 'ID of received line was not the expected value (CRC16-ext)',
    '0X002D': 'Received line was too short to extract a header (CRC16-ext)',
    '0X002E': 'Settings are not initialized',
    '0X002F': 'Channel is not available for this device',
    '0X0030': 'Calibration process has failed',
    '0X0032': 'Critical cell overload, aborting measurement to prevent damage.',
    '0X0033': 'FLASH ECC error has occurred',
    '0X0034': 'Flash program operation failed',
    '0X0035': 'Flash Erase operation failed',
    '0X0036': 'Flash page/block is locked',
    '0X0037': 'Flash write operation on protected memory',
    '0X0038': 'Flash is busy executing last command.',
    '0X0039': 'Operation failed because block was marked as bad',
    '0X003A': 'The specified address is not valid',
    '0X003B': 'An error has occurred while attempting to mount the filesystem',
    '0X003C': 'An error has occurred while attempting to format the filesystem memory',
    '0X003D': 'A timeout has occurred during SPI communication',
    '0X003E': 'A timeout has occurred somewhere',
    '0X003F': 'The calibrations registers are locked, write actions not allowed.',
    '0X0040': 'Memory module not supported.',
    '0X0041': 'Flash memory format not recognized or supported.',
    '0X0042': 'This register is locked for current permission level.',
    '0X0043': 'Register is write-only',
    '0X0044': 'Command requires additional initialization',
    '0X0045': 'Configuration not valid for this command',
    '0X0046': 'The multiplexer was not found.',
    '0X0047': 'The filesystem has to be mounted to complete this action.',
    '0X0048': 'This device is not a multi-device, no serial available.',
    '0X004A': 'MCU register access is not allowed, only RAM and peripherals are accessible.',
    '0X004B': 'Runtime (comm) command argument too short to be valid.',
    '0X004C': 'Runtime (comm) command argument has an invalid format.',
    '0X004E': 'Hibernate wake up source is invalid',
    '0X004F': 'Hibernate requires at least one wake up source, none was given.',
    '0X0050': 'Wake pin for hibernate not configured as `input`',
    '0X0051': 'The code provided to the permission register was not valid.',
    '0X0052': 'An overrun error occurred on a communication interface (e.g. UART).',
    '0X0053': 'Argument length incorrect for this register.',
    '0X0055': 'The GPIO pins requested to change do not exist on this instrument.',
    '0X0056': 'The selected GPIO pin mode is not allowed (by NVM config or device type).',
    '0X0057': 'The on-board flash module has timed out.',
    '0X0058': 'Timing error during fast measurement (possibly caused by communication).',
    '0X005A': 'The instrument cannot meet the requested measurement timing.',
    '0X005B': 'The variable type is already being measured.',
    '0X006D': 'The COMM command expected an hexadecimal value, but received something else.',
    '0X006E': 'The COMM command expected a decimal value, but received something else.',
    '0X0071': 'The provided key does not fit the lock on this register.',
    '0X0072': 'I2C port expander did not acknowledge a command',
    '0X0073': 'Filesystem module not supported',
    '0X0074': 'The IP address is not available (yet).',
    '0X007A': 'There is no measurement channel left for the requested measurement.',
    '0X007B': 'Temperature measurements during EIS with > 8 kHz are not supported.',
    '0X007C': 'The specified mode is unknown',
    '0X007D': 'The ADXL367 did not acknowledge an I2C command',
    '0X007E': 'An unexpected error occurred during an I2C operation.',
    '0X007F': 'I2C bus timeout during I2C operation (probably caused by I2C target device).',
    '0X0080': 'The CE is oscillating.',
    '0X0082': 'Operation requires system warnings to be cleared.',
    '0X0083': 'Filesystem operations are not supported on this device.',
    '0X0084': 'The requested variable type does not support ranging.',
    '0X0085': 'The selected GPIO pin does not support harware synchronisation.',
    '0X0086': 'Hardware select must be disabled before the `role` pin can be disabled.',
    '0X0087': 'The `role` pin must be configured before the hadware select can be enabled',
    '0X0088': 'The instrument has reserved this GPIO pin to be controlled by hardware (e.g. file system or HW-sync).',
    '0X0089': 'This GPIO pin cannot be unlocked, as it was not locked in the first place',
    '0X008A': 'This GPIO pin can only be used for interfacing with a specific external memory',
    '0X008B': 'The BiPot should be disabled.',
    '0X008C': 'iR compensation should be disabled.',
    '0X008D': 'The key provided for the reset command is incorrect.',
    '0X008E': 'The SPI interface is not confgiured while it is required for the filesystem',
    '0X008F': "The SPI interface requires the SPI pins to be configured to 'peri 1'",
    '0X0090': 'The GPIO pin cannot be mapped to this signal as it is used by the hw_sync_iterate signal',
    '0X0091': 'The GPIO pin cannot be mapped to this signal as it is used by the hw_sync_start signal',
    '0X0092': 'The GPIO pin cannot be mapped to this signal as it is used by the hw_sync_role signal',
    '0X0093': 'The GPIO pin cannot be mapped to this signal as it is used by the led_red signal',
    '0X0094': 'The GPIO pin cannot be mapped to this signal as it is used by the led_green signal',
    '0X0095': 'The GPIO pin cannot be mapped to this signal as it is used by the led_blue signal',
    '0X0096': 'The GPIO pin does not suppport mapping the requested signal',
    '0X0097': 'The requested signal is not mapped to a GPIO',
    '0X0098': 'The configuration set using the Peripheral configuration (0x01) register is invalid',
    '0X0099': 'Filesystem file is corrupt',
    '0X009A': 'Filesystem failed to format',
    '0X009B': 'Filesystem I/O error',
    '0X009C': "Filesystem didn't have enough memory to perform the operation",
    '0X009D': 'Filesystem path was too long to handle',
    '0X009E': 'Filesystem the path was not valid',
    '0X009F': 'Filesystem could not find the file specified',
    '0X00A0': 'Filesystem FM not supported',
    '0X00A1': "Filesystem doesn't have a listing",
    '0X00A2': 'Filesystem is not initialized',
    '0X00A3': 'Filesystem file is open, but it should not have been',
    '0X00A4': 'Filesystem file is not open',
    '0X00A5': 'Filesystem does not support this feature',
    '0X00A6': 'Filesystem expected something which is not true.',
    '0X00A7': 'Filesystem could not find the path',
    '0X00A8': 'Access denied due to prohibited access or directory full',
    '0X00A9': 'The file/directory object is invalid',
    '0X00AA': 'The physical drive is write protected',
    '0X00AB': 'The logical drive number is invalid',
    '0X00AC': 'There is no valid filesystem volume',
    '0X00AD': 'The format operation was aborted due to any problem',
    '0X00AE': 'The operation is rejected according to the file sharing policy',
    '0X00AF': 'Working buffer could not be allocated',
    '0X00B0': 'Too many files opened at once by filesystem',
    '0X00B1': 'Parameter given to the filesystem is invalid',
    '0X00B2': 'The file mode is invalid (should be readonly, new, append, overwrite).',
    '0X00B3': 'The pin mode requred for the LED mapping is not allowed for this pin',
    '0X00B4': 'The pin mode requred for the HW-sync role is not allowed for this pin',
    '0X00B5': 'The pin mode requred for the HW-sync start mapping is not allowed for this pin',
    '0X00B6': 'Use of the encrypted filesystem failed',
    '0X00B7': 'The user key is not in a valid state for this cmmand',
    '0X00B8': 'The communications protocol is not in valid lock state for this command',
    '0X00B9': 'Cannot reserve the memory needed for this string',
    '0X00BA': 'Writing to the GPIO pin requires that it is configured as output',
    '0X00BB': 'Reading a GPIO pin requires that it is configured as input',
    '0X00BC': 'Pull-up resistors can only be enabled on inputs',
    '0X00BD': 'The requested multiplexer is not valid for this instrument',
    '0X00BE': 'The requested MethodSCRIPT pin is not configured (may be unmapped)',
    '0X00BF': 'The signal hw_sync_iterate is already mapped to a GPIO pin, please unmap first',
    '0X00C0': 'The signal hw_sync_start is already mapped to a GPIO pin, please unmap first',
    '0X00C1': 'The signal hw_sync_role is already mapped to a GPIO pin, please unmap first',
    '0X00C2': 'The signal led_red is already mapped to a GPIO pin, please unmap first',
    '0X00C3': 'The signal led_green is already mapped to a GPIO pin, please unmap first',
    '0X00C4': 'The signal led_blue is already mapped to a GPIO pin, please unmap first',
    '0X00C5': 'The hardware synchronisation mode is not supported by the instrument',
    '0X00C6': 'The HW sync is configured while the iterate signal is not mapped to a GPIO pin',
    '0X00C7': 'The HW sync is configured while the start signal is not mapped to a GPIO pin',
    '0X00C8': 'The HW sync is configured with HW-select while the role signal is not mapped to a GPIO pin',
    '0X00C9': 'The GPIO pin cannot be mapped to this signal as it is used by the we0_enable signal',
    '0X00CA': 'The GPIO pin cannot be mapped to this signal as it is used by the ce0_enable signal',
    '0X00CB': 'The GPIO pin cannot be mapped to this signal as it is used by the we1_enable signal',
    '0X00CC': 'The GPIO pin cannot be mapped to this signal as it is used by the ce1_enable signal',
    '0X00CD': 'The GPIO pin cannot be mapped to this signal as it is used by the user_i2c_scl signal',
    '0X00CE': 'The GPIO pin cannot be mapped to this signal as it is used by the user_i2c_sda signal',
    '0X00CF': 'The GPIO pin cannot be mapped to this signal as it is used by the spi_clk signal',
    '0X00D0': 'The GPIO pin cannot be mapped to this signal as it is used by the spi_mosi signal',
    '0X00D1': 'The GPIO pin cannot be mapped to this signal as it is used by the spi_miso signal',
    '0X00D2': 'The GPIO pin cannot be mapped to this signal as it is used by the spi_cs signal',
    '0X00D3': 'The signal we0_enable is already mapped to a GPIO pin, please unmap first',
    '0X00D4': 'The signal ce0_enable is already mapped to a GPIO pin, please unmap first',
    '0X00D5': 'The signal we1_enable is already mapped to a GPIO pin, please unmap first',
    '0X00D6': 'The signal ce1_enable is already mapped to a GPIO pin, please unmap first',
    '0X00D7': 'The signal user_i2c_scl is already mapped to a GPIO pin, please unmap first',
    '0X00D8': 'The signal user_i2c_sda is already mapped to a GPIO pin, please unmap first',
    '0X00D9': 'The signal spi_clk is already mapped to a GPIO pin, please unmap first',
    '0X00DA': 'The signal spi_mosi is already mapped to a GPIO pin, please unmap first',
    '0X00DB': 'The signal spi_miso is already mapped to a GPIO pin, please unmap first',
    '0X00DC': 'The signal spi_cs is already mapped to a GPIO pin, please unmap first',
    '0X4001': 'The script command is unknown',
    '0X4004': 'An unexpected character was encountered',
    '0X4005': 'The script is too large for the internal script memory',
    '0X4008': 'This optional argument is not valid for this command',
    '0X4009': 'The stored script is generated for an older firmware version and cannot be run',
    '0X400B': 'Measurement loops cannot be placed inside other measurement loops',
    '0X400C': 'Command not supported in current situation',
    '0X400D': 'Scope depth too large',
    '0X400E': 'The command had an invalid effect on scope depth',
    '0X400F': 'Array index out of bounds',
    '0X4010': 'I2C interface was not initialized with i2c_config command',
    '0X4011': 'This is an error, NAck flag not handled by script',
    '0X4012': 'Something unexpected went wrong.',
    '0X4013': 'I2C clock frequency not supported by hardware',
    '0X4014': 'Non integer SI vars cannot be parsed from hex or binary representation',
    '0X4016': 'RTC was selected as wake-up source and selected time is not supported',
    '0X4017': 'Arrays must be the same size but are not',
    '0X4018': 'The script has ended unexpectedly.',
    '0X4019': 'The script command is only valid for a multichannel (combined) device',
    '0X401A': 'The script command cannot be called from within a measurement loop.',
    '0X401B': 'the pck sequence is called wrong',
    '0X401C': 'The maximum amounts of variables per packet has been exceeded.',
    '0X401D': 'The file path is too long for the file system.',
    '0X401E': 'Insufficient memory to store array index',
    '0X4020': 'A timeout has occurred for one of the script commands',
    '0X4021': 'The mux is not initialized/configured.',
    '0X4022': 'Measurement loop timing is too fast to use with multiplexer',
    '0X4023': 'The script command is only valid for a device with iR compensation',
    '0X4024': 'The resistance value is to big for the whole autorange range',
    '0X4025': 'The resistance value is to big for current current range',
    '0X4026': 'The variable already exists when declared',
    '0X4027': 'This command requires the cell to be enabled with the `cell_on` command',
    '0X4028': 'This command requires the cell to be disabled with the `cell_off` command',
    '0X4029': 'The technique requires that at least one step should be made',
    '0X402A': 'The variable names do not fit in memory anymore, try using shorter names.',
    '0X402B': "The variable name did not start with 'a'-'z' or otherwise contained anything other than 'a'-'z', '0'-'9' and '_'.",
    '0X402C': 'The variable name is too long to be processed.',
    '0X402D': 'The file mode is invalid.',
    '0X402E': 'The file mode does not support a counter in the file path.',
    '0X402F': 'The file path with the maximum counter value already exists.',
    '0X4030': 'There are too many files open already.',
    '0X4031': 'The specified multi device type is not defined.',
    '0X4032': 'Cannot set the potential (or potential range) within the active measurement loop.',
    '0X4033': 'Cannot set the current (or current range) within the active measurement loop.',
    '0X4034': 'The used feature is not licensed on this product.',
    '0X4035': 'The given filter type is unknown or not supported.',
    '0X4036': 'The given command is only allowed within measurement loops.',
    '0X4037': 'A computation has resulted in an overflow',
    '0X4038': 'The array access was not correctly formed',
    '0X4039': 'The literal argument was not correctly formed',
    '0X403A': 'The subarray declaration was out of bounds for the source array',
    '0X403B': 'A file needs to be opened before it can be written to',
    '0X403C': 'The MethodScript output mode is unknown',
    '0X4200': 'MScript argument value cannot be negative for this command',
    '0X4201': 'MScript argument value cannot be positive for this command',
    '0X4202': 'MScript argument value cannot be zero for this command',
    '0X4203': 'MScript argument value must be negative for this command (also not zero)',
    '0X4204': 'MScript argument value must be positive for this command (also not zero)',
    '0X4205': 'MScript argument value is outside the allowed bounds for this command',
    '0X4206': 'MScript argument value cannot be used for this specific instrument',
    '0X4207': 'MScript argument datatype (float/int) is invalid for this command',
    '0X4208': "MScript argument reference was invalid (not 'a' - 'z')",
    '0X4209': 'MScript argument variable type is invalid or not supported for this command',
    '0X420A': 'An unexpected, additional, (optional) MScript argument was provided',
    '0X420B': 'MScript argument variable is not declared',
    '0X420C': 'MScript argument is of type var, which is not supported by this command',
    '0X420D': 'MScript argument is of type literal, which is not supported by this command',
    '0X420E': 'MScript argument is of type array, which is not supported by this command',
    '0X420F': 'MScript argument array size is insufficient',
    '0X4210': 'An f-string contains an opening brace that is never closed',
    '0X4211': 'MScript argument is an array element, which is not supported by this command',
    '0X4212': 'MScript argument is an uninitialized string, which is not supported by this command',
    '0X7FFF': 'A fatal error has occurred, the device must be reset',
};
